// Legacy Resources component - redirecting to new ResourcesCenter
import React from "react";
import ResourcesCenter from "./Resources/ResourcesCenter";

const ResourcesInit: React.FC = () => {
    // Simply return the new ResourcesCenter component
    return <ResourcesCenter />;
};

export default ResourcesInit;
